// assets
import Margaritas from "../assets/margaritas.jpg";

export default function MiVision() {
    return (
        <div className="container">
            <div className="theme-band"></div>
            <div className="article">
                <h1>Mi visión del Reiki</h1>
                <h2>REIKI, ¿QUÉ ES? ¿QUÉ EFECTOS TIENE?</h2>
                <p>
                    El Reiki es LUZ. Y como luz que es, alumbra y nos permite
                    ver dentro de nosotr@s zonas o aspectos que hasta ahora
                    habían pasado desapercibidos.
                </p>
                <p>
                    Haciendo un símil con una casa, el cuerpo que habitamos está
                    lleno de habitaciones y de recovecos, en los que puede ser
                    que no hayamos entrado nunca.
                </p>
                <p>
                    El efecto del Reiki es poder ver sentimientos, situaciones,
                    actitudes, valores, creencias... todo aquello que está en
                    nuestro interior, más o menos tapado, impidiéndonos, en
                    algunos casos, disfrutar de la vida, en otros sostener una
                    relación de pareja, comprender a nuestros hijos, realizarnos
                    profesionalmente, vivir en paz una enfermedad o cualquier
                    otra circunstancia.
                </p>
                <p>
                    El Reiki tiene el efecto de{" "}
                    <strong>aumentar nuestra comprensión</strong> sobre lo que
                    estamos viviendo, nos muestra el sentido de vivencias a las
                    que no les encontrábamos el sentido, nos ofrece una{" "}
                    <strong>visión nueva y diferente</strong> de nosotros
                    mismos, la <strong>VISIÓN INTERIOR</strong>.
                </p>
                <br />
                <h2>¿PARA QUIÉN ES ACONSEJABLE UNA SESIÓN DE REIKI?</h2>
                <p>
                    Si estás atravesando una etapa de tu vida con dificultades,
                    bien sea una enfermedad, una ruptura, la muerte de un ser
                    querido, pérdida del trabajo o cualquier circunstancia que
                    para tí sea complicada,
                </p>
                <p>
                    Si vives en una montaña rusa de emociones, o en la
                    indecisión permanente; si quieres profundizar en tí,
                    identificar y liberar esos miedos o esas creencias
                    limitantes que te atenazan, esos códigos sociales o
                    familiares que te impiden ser tú mism@,
                </p>
                <p>Si buscas Paz,</p>
                <p>Te acompaño con REIKI</p>

                <img
                    src={Margaritas}
                    alt="El reiki actúa siempre a favor de la vida"
                    className="img-center"
                />

                <br />
                <h2>¿CÓMO ES UNA SESIÓN DE REIKI?</h2>
                <p>
                    El Reiki puede practicarse de tantas formas y en tantos
                    lugares como alcance nuestra imaginación. No tiene límites.
                    Se puede practicar de pie, sentado, tumbado, caminando, en
                    un lugar cerrado, en la naturaleza, con música, sin
                    música...
                </p>
                <p>También puede realizarse presencialmente y a distancia.</p>
                <p>
                    Una sesión de Reiki propicia el encuentro de corazón a
                    corazón, abre un campo de conexión de Ser a Ser y con la
                    Conciencia Universal.
                </p>
                <p>
                    Y es, precisamente, la apertura a esa Conciencia de la
                    Unidad que somos la que permite que una sesión de Reiki
                    pueda hacerse de forma presencial y también a distancia.
                    Nuestro campo energético que no vemos, pero sentimos, forma
                    parte del campo energético Universal. Aquí, en la materia
                    nos percibimos separados, pero en planos interiores somos
                    UNIDAD.
                </p>
                <br />
                <h2>¿QUÉ SE SIENTE AL RECIBIR REIKI?</h2>
                <p>
                    Las percepciones físicas o sensoriales de una sesión de
                    Reiki pueden ser muy variadas y más o menos agradables. Se
                    puede sentir calor, frío, un ligero picor, cosquilleo... a
                    veces cierta incomodidad.{" "}
                </p>
                <p>
                    En cualquier caso, con la práctica continuada de Reiki se
                    siente bienestar, lucidez, comprensión, expansión de
                    conciencia, re-encuentro con un@ mism@.
                </p>
                <p>
                    Y, como en cualquier otro re-encuentro puede ser que afloren
                    recuerdos, memorias,.. de dolor, de sufrimiento, que
                    puntualmente no nos resulten fáciles de asimilar.
                </p>
                <p>
                    Puede ser también que tomemos conciencia de situaciones que
                    nos invitan a tomar decisiones difíciles. Dejar atrás
                    hábitos, costumbres, relaciones que no nos benefician,
                    trabajos que nos están asfixiando, códigos sociales o
                    familiares limitantes... no siempre es sencillo.
                </p>
                <p>
                    Reiki es un excelente acompañamiento en este camino. Te
                    recarga y te apoya siempre de forma incondicional, sin
                    juicio.
                </p>
                <br />
            </div>
        </div>
    );
}
